import React from 'react';
import { Stack, Typography } from '@mui/material';
import { isString } from 'lodash';

import { PaymentStatusChip } from '../PaymentStatusChip';

import { Props } from './props';

export const TitleInfoBadge: React.FC<Props> = (props) => {
  const {
    title,
    desc,
    titleProps,
    titleContainerProps,
    descProps,
    tagStatus,
    postFix,
    ...restProps
  } = props;

  const renderTag = () => {
    if (isString(tagStatus)) return <PaymentStatusChip status={tagStatus} />;
    return tagStatus;
  };

  return (
    <Stack direction="column" {...restProps}>
      <Stack
        direction={'row'}
        alignItems={'center'}
        gap={2}
        {...titleContainerProps}
      >
        {title && (
          <Typography
            {...titleProps}
            sx={{
              fontWeight: 600,
              fontSize: '16px',
              color: 'primary',
              ...titleProps?.sx,
            }}
          >
            {title}
          </Typography>
        )}
        {tagStatus && renderTag()}
      </Stack>
      <Typography
        {...descProps}
        sx={{
          fontWeight: 600,
          fontSize: '14px',
          color: '#666666',
          ...descProps?.sx,
        }}
      >
        {desc}
      </Typography>
      {postFix && postFix}
    </Stack>
  );
};

export default TitleInfoBadge;
